import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { usePageSeo } from './usePageSeo';
import './css/pages/about.css';

// Images
import Icon_Mail from './image/mail.svg';
import Icon_LinkedIn from './image/linkedin_black.png';
import Img_ConnectedPersons from './image/simple/undraw_connected_dark.svg';
import Img_Goals from './image/simple/undraw_shared_goals.svg';
import Img_Nick from './image/portret_nick.jpg';
import Img_Rick from './image/portret_rick.jpg';

export const About = () => {
    const { t } = useTranslation();
    usePageSeo('seo.about.title', 'seo.about.description');
    const translatedVisionPoints = t('about.visionPoints', { returnObjects: true });
    const visionPoints = Array.isArray(translatedVisionPoints) ? translatedVisionPoints : [];

    return(
        <span>
            <div class="container vb-about-content-top vb-about-section vb-about-section--intro">
                <div class="row">
                    <div class="p-4 col-lg-6 col-sm-12">
                        <div class="vb-about-intro-panel">
                            <h5 class="vb-about-subtitle">{t('about.sectionTitle')}</h5>
                            <h1 class="vb-about-title">{t('about.title')}</h1>
                            <p class="vb-about-text">
                                {t('about.body')}
                            </p>
                            <div class="vb-general-margintop50">
                                <Link to="/contact" style={{ textDecoration: 'none' }}>  
                                    <button type="submit" class="btn btn-primary vb-button">{t('common.contactCta')}</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div class="p-4 col-lg-6 col-sm-12">
                        <img src={Img_ConnectedPersons} class="vb-about-title-image vb-about-illustration" alt="Samenwerkend team"></img>
                    </div>
                </div>
            </div>
            <div class="vb-about-content-contrast vb-about-content-contrast--vision">  
                <div class="container vb-about-content">
                    <div class="row">
                        <div class="col-lg-12">
                            <h5 class="vb-about-subtitle-center">{t('about.visionTitle')}</h5>
                        </div>
                    </div>
                    <div class="row vb-about-vision-row">
                        <div class="p-4 col-lg-6 col-sm-12">
                        <img src={Img_Goals} class="vb-about-title-image vb-about-illustration" alt="Visie en doelen"></img>
                        </div>
                        <div class="p-4 col-lg-6 col-sm-12">
                            <div class="vb-about-vision-panel">
                                <p class="vb-about-text">
                                    {t('about.visionBody')}
                                </p>
                                <ul class="vb-about-vision-list">
                                    {visionPoints.map((point) => (
                                        <li key={point}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container vb-about-content vb-about-section vb-about-section--team">
                <div class="row">
                    <div class="col-lg-12">
                        <h5 class="vb-about-subtitle-center">{t('about.teamTitle')}</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="p-4 col-lg-6 col-sm-12">
                        {/* Rick */}
                        <div class="vb-about-bio-box">
                            {/* Image */}
                            <img src={Img_Rick} class="vb-img-radius-300" alt="Rick Vervelde"></img>
                            <h3 class="vb-about-bio-name">Rick Vervelde</h3>
                            <span class="vb-about-icon-box">
                                <a href= "mailto: rick.vervelde@vbcontrol.com">
                                    <img src={Icon_Mail} class="vb-about-icon" alt="E-mail Rick"></img>
                                </a>
                                <a href="https://www.linkedin.com/in/rick-vervelde-017729179/" target='_blank' rel='noreferrer'>
                                    <img src={Icon_LinkedIn} class="vb-about-icon" alt="LinkedIn Rick"></img>
                                </a>
                            </span>

                        </div>
                    </div>
                    <div class="p-4 col-lg-6 col-sm-12">
                        {/* Nick */}
                        <div class="vb-about-bio-box">
                            {/* Image */}
                            <img src={Img_Nick} class="vb-img-radius-300" alt="Nick Burggraaff"></img>
                            <h3 class="vb-about-bio-name">Nick Burggraaff</h3>
                            <span class="vb-about-icon-box">
                                <a href="mailto: nick.burggraaff@vbcontrol.com">
                                    <img src={Icon_Mail} class="vb-about-icon" alt="E-mail Nick"></img>
                                </a>
                                <a href="https://www.linkedin.com/in/nickburggraaff/" target='_blank' rel='noreferrer'>
                                    <img src={Icon_LinkedIn} class="vb-about-icon" alt="LinkedIn Nick"></img>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </span>
    )
}